import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TREND_UP, TREND_DOWN } from '../../consts';

class PriceHistory extends Component {
  constructor (props) {
    super(props);

    this.state = {
      opened: false
    };

    this.previewRows = props.history.splitItems(props.previewLine);
    this.moreRows = props.history.splitItems(props.previewLine, true);
    this.fixedHeight = this.moreRows && this.props.fixedHeight;
    this.colSpan = this.props.showDelta ? 4 : 3;

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick (e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      opened: !this.state.opened
    });
  };

  renderTrend (trend) {
    const abbr = trend === TREND_UP ? '\ue931' : (trend === TREND_DOWN ? '\ue930' : '');
    return abbr && <span className={'trend ' + trend}>{abbr}</span>;
  }

  renderRow (items) {
    if (!items) {
      return null;
    }

    const showDelta = this.props.showDelta;

    return items.map((v, i) => {
      return (
        <tr key={i}>
          <td className='date'>{v.getDate().format('DD\u00A0MMMM\u00A0YYYY')}</td>
          <td className='price'>{v.getPrice().getLabel()}</td>
          <td className={'delta ' + v.getTrend()}>
            {v.getDeltaPercentLabel()}
            {this.renderTrend(v.getTrend())}
          </td>
          {showDelta ? <td>{v.getDelta().getLabel()}</td> : null}
        </tr>
      );
    });
  }

  renderMoreLink () {
    const className = (!this.state.opened && this.moreRows) || 'hide';

    return (
      <tr className={className}>
        <td className='more-link-wrp' colSpan={this.colSpan} onClick={this.handleClick}>
          <div className='more-link'>подробнее</div>
        </td>
      </tr>
    );
  }

  render () {
    const scrollClass = this.state.opened && this.fixedHeight ? 'scroll-wrp' : '';
    return (
      <div className='price-history-modal-wrp'>
        <div className={scrollClass}>
          <table className='table table-no-bordered'>
            <tbody>
              {this.renderRow(this.previewRows)}
              {this.renderMoreLink()}
              {this.state.opened && this.renderRow(this.moreRows)}
            </tbody>
          </table>
        </div>
        <div className='footer'>
          <hr style={{width: '100%'}} />
          <span className='label'>Нач. цена</span>
          <span className='price'>{this.props.history.getStartPrice().getLabel()}</span>
        </div>
      </div>
    );
  }
}

PriceHistory.propTypes = {
  history: PropTypes.object.isRequired,
  previewLine: PropTypes.number,
  showDelta: PropTypes.bool,
  fixedHeight: PropTypes.bool
};

PriceHistory.defaultProps = {
  previewLine: 5,
  showDelta: false,
  fixedHeight: true
};

export default PriceHistory;



// WEBPACK FOOTER //
// ./src/ui/Price/PriceHistory.jsx